module.exports = __webpack_public_path__ + "static/media/github_logo.a7686024.svg";